import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=499dda23&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports